import Container from "../components/Container";

export default function Hero() {
  return (
    <section className="bg-brand-light h-screen flex items-center">
      <Container>
        <div className="max-w-4xl text-center mx-auto">
          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-7xl font-extrabold leading-tight mb-8">
            Traditional ingredients,
            <br />
            made for modern life.
          </h1>

          <p className="text-lg sm:text-xl md:text-2xl text-gray-700 mb-12 max-w-3xl mx-auto">
            Teddy’s Tallow crafts everyday products centered around tallow — from food to skincare — with uncompromising quality.
          </p>

          <div className="flex justify-center flex-wrap gap-4">
            <a
              href="https://teddystallowchips.com"
              className="inline-block bg-brand-dark text-white px-8 py-4 rounded-full text-sm md:text-base font-medium hover:opacity-90 transition"
            >
              Explore Chips
            </a>

            <a
              href="https://teddystallowbalm.com"
              className="inline-block border border-brand-dark px-8 py-4 rounded-full text-sm md:text-base font-medium hover:bg-brand-dark hover:text-white transition"
            >
              Explore Balm
            </a>
          </div>
        </div>
      </Container>
    </section>
  );
}
